import React from "react";
import classes from "./CommonButton.module.scss";

/**
 * 共通ボタンプロパティ
 */
type CommonButtonProps = {
  /** 幅 100% にするか */
  fullWidth?: boolean;
  /** 押下可能状態 */
  disabled?: boolean;
  /** アウトラインスタイルの ON/OFF */
  outline?: boolean;
  /** ボタンクリックイベント */
  onClick: () => void;
};

/**
 * 共通ボタン
 * @param props 共通ボタンプロパティ
 */
const CommonButton: React.FC<CommonButtonProps> = (props) => {
  const buttonClasses = [classes.commonButton];
  if (props.outline) {
    buttonClasses.push(classes.outline);
  }
  if (props.fullWidth) {
    buttonClasses.push(classes.fullWidth);
  }

  return (
    <button
      type="button"
      disabled={props.disabled}
      className={buttonClasses.join(" ")}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};

CommonButton.defaultProps = {
  fullWidth: false,
  disabled: false,
  outline: false,
};

export default CommonButton;
